import React, {useContext} from 'react';
import AuthContext from "../context/AuthProvider";
import {Link, Navigate} from "react-router";
import {Helmet} from "react-helmet";
import LogoutButton from "./LogoutButton";
import FraudioLoader from "./FraudioLoader";
import bgkupa from "../assets/bgkupa.png";
import kupavideo from "../assets/videos/kupa.mp4";

const cardStyle = {
    background: "rgba(255,255,255,0.04)",
    border: "1px solid rgba(255,215,0,0.18)",
    borderRadius: "16px",
    padding: "28px 32px",
    marginBottom: "24px",
};

const cardHeaderStyle = {
    display: "flex",
    alignItems: "flex-start",
    gap: "18px",
    marginBottom: "20px",
};

const badgeStyle = {
    background: "linear-gradient(135deg, #FFD700 0%, #B8860B 100%)",
    color: "#050c23",
    fontWeight: 800,
    fontSize: "12px",
    letterSpacing: "1.5px",
    padding: "7px 16px",
    borderRadius: "20px",
    whiteSpace: "nowrap",
    flexShrink: 0,
    marginTop: "3px",
};

const cardTitleStyle = {
    color: "#fff",
    fontWeight: 700,
    fontSize: "18px",
    marginBottom: "5px",
    letterSpacing: "0.4px",
};

const cardDescStyle = {
    color: "rgba(255,255,255,0.5)",
    fontSize: "13px",
    margin: 0,
    lineHeight: 1.5,
};

function Kupa() {
    const { auth } = useContext(AuthContext);

    if (auth !== "kupa@audiotime.com.tr") {
        return <Navigate to="/giris" />;
    }

    return (
        <React.Fragment>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript"/>
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`}/>
            </Helmet>

            {/* ── HERO ── */}
            <div style={{
                backgroundImage: `url(${bgkupa})`,
                backgroundSize: "cover",
                backgroundPosition: "center right",
                position: "relative",
                minHeight: "420px",
                display: "flex",
                alignItems: "center",
                padding: "140px 0 60px",
            }}>
                <div style={{
                    position: "absolute",
                    inset: 0,
                    background: "linear-gradient(to right, rgba(4,10,30,0.97) 30%, rgba(4,10,30,0.80) 58%, rgba(4,10,30,0.25) 100%)",
                }} />

                <div className="container" style={{position: "relative", zIndex: 1}}>
                    <div className="row">
                        <div className="col-lg-7 col-md-9">

                            <h1 style={{
                                color: "#FFD700",
                                fontSize: "clamp(30px, 4.5vw, 58px)",
                                fontWeight: 900,
                                letterSpacing: "2px",
                                textTransform: "uppercase",
                                lineHeight: 1.1,
                                marginBottom: "8px",
                                textShadow: "0 0 40px rgba(255,215,0,0.35)",
                                display: "flex",
                                alignItems: "center",
                                gap: "16px",
                            }}>

                                DÜNYA KUPASI <span style={{fontSize: "0.85em"}}>🏆</span>
                            </h1>
                            <h2 style={{
                                color: "rgba(255,255,255,0.7)",
                                fontSize: "clamp(13px, 1.8vw, 18px)",
                                fontWeight: 400,
                                letterSpacing: "5px",
                                textTransform: "uppercase",
                                marginBottom: "20px",
                            }}>
                                YAPAY ZEKA DEMO
                            </h2>

                            <div style={{
                                width: "60px",
                                height: "2px",
                                background: "linear-gradient(to right, #FFD700, transparent)",
                                marginBottom: "22px",
                            }} />

                            <p style={{
                                color: "rgba(255,255,255,0.55)",
                                fontSize: "14px",
                                lineHeight: 1.7,
                                maxWidth: "440px",
                                marginBottom: "28px",
                            }}>
                                Dünya Kupası yayınlarına özel yapay zeka ses reklamları.
                                Anlık maç skorları, atmosfer ve milli takım haberlerine göre
                                kişiselleştirilmiş dinamik reklam sesleri.
                            </p>

                            <div style={{display: "flex", alignItems: "center", gap: "24px", flexWrap: "wrap", marginBottom: "0"}}>
                                <ul className="breadcumb__list" style={{margin: 0}}>
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">DÜNYA KUPASI</li>
                                </ul>
                                <LogoutButton />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── PLAYERS ── */}
            <div style={{
                background: "linear-gradient(180deg, #040a1e 0%, #081228 100%)",
                padding: "60px 0 90px",
            }}>
                <div className="container">

                    {/* section title */}
                    <div className="row justify-content-center" style={{marginBottom: "40px"}}>
                        <div className="col-lg-8 col-md-10 text-center">
                            <p style={{
                                color: "#FFD700",
                                fontSize: "11px",
                                letterSpacing: "4px",
                                textTransform: "uppercase",
                                marginBottom: "8px",
                            }}>Demo Ses Reklamları</p>
                            <h3 style={{
                                color: "#fff",
                                fontSize: "24px",
                                fontWeight: 700,
                                margin: 0,
                            }}>
                                3 Farklı Senaryo
                            </h3>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-md-10">

                            {/* Player 1 */}
                            <div style={cardStyle}>
                                <div style={cardHeaderStyle}>
                                    <span style={badgeStyle}>⚽ 01</span>
                                    <div>
                                        <h4 style={cardTitleStyle}>GERİ SAYIM</h4>
                                        <p style={cardDescStyle}>En yakındaki maça ne kadar süre kaldığını söyler!</p>
                                    </div>
                                </div>
                                <FraudioLoader
                                    src="https://audiotime.clerkai.app/kupa1.php"
                                    title="Maç Skoru"
                                    artist="Dünya Kupası Yapay Zeka"
                                />
                            </div>

                            {/* Player 2 */}
                            <div style={cardStyle}>
                                <div style={cardHeaderStyle}>
                                    <span style={badgeStyle}>🏟️ 02</span>
                                    <div>
                                        <h4 style={cardTitleStyle}>STADYUM ATMOSFERİ</h4>
                                        <p style={cardDescStyle}>Maç öncesi ve sonrası heyecanı yansıtan atmosfer reklamı, maçlar başlamadığından bilgiler gerçeği yansıtmamaktadır. Demo amaçlı hazırlanmıştır</p>
                                    </div>
                                </div>
                                <FraudioLoader
                                    src="https://audiotime.clerkai.app/kupa2.php"
                                    title="Stadyum Atmosferi"
                                    artist="Dünya Kupası Yapay Zeka"
                                />
                            </div>

                            {/* Player 3 */}
                            <div style={cardStyle}>
                                <div style={cardHeaderStyle}>
                                    <span style={badgeStyle}>🌍 03</span>
                                    <div>
                                        <h4 style={cardTitleStyle}>CANLI MAÇ SUNUMU</h4>
                                        <p style={cardDescStyle}>Canlı olarak maçlardaki son durumu yayınlar. Örnek olarak demo amaçlı üretilmiştir, gerçeği yansıtmaz</p>
                                    </div>
                                </div>
                                <FraudioLoader
                                    src="https://audiotime.clerkai.app/kupa3.php"
                                    title="Milli Takım"
                                    artist="Dünya Kupası Yapay Zeka"
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* ── BANNERS (Prado-style) ── */}
            <div style={{background: "#060e22", borderTop: "1px solid rgba(255,215,0,0.08)"}}>

                {/* Section header */}
                <div className="container" style={{paddingTop: "70px", paddingBottom: "60px", borderBottom: "1px solid rgba(255,255,255,0.05)"}}>
                    <p style={{color: "#FFD700", fontSize: "11px", letterSpacing: "4px", textTransform: "uppercase", marginBottom: "12px"}}>
                        Video Reklam Formatları
                    </p>
                    <h2 style={{color: "#fff", fontSize: "clamp(22px, 3.5vw, 40px)", fontWeight: 900, margin: 0, maxWidth: "560px", lineHeight: 1.2}}>
                        Rewarded Zirvede Kalıyor.<br />
                        <span style={{color: "rgba(255,255,255,0.45)", fontWeight: 400}}>Interstitial Hızla Yükseliyor.</span>
                    </h2>
                </div>

                {/* ── Format 1: Rewarded Video ── */}
                <div className="container" style={{paddingTop: "80px", paddingBottom: "80px", borderBottom: "1px solid rgba(255,255,255,0.05)"}}>
                    <div className="row align-items-center g-4">

                        {/* Phone mockup */}
                        <div className="col-lg-3">
                            <div style={{maxWidth: "280px", width: "100%", margin: "0 auto", background: "#111827", border: "3px solid rgba(255,255,255,0.10)", borderRadius: "44px", padding: "14px", boxShadow: "0 40px 100px rgba(0,0,0,0.7)", position: "relative"}}>
                                <div style={{position: "absolute", top: "14px", left: "50%", transform: "translateX(-50%)", width: "56px", height: "5px", background: "rgba(255,255,255,0.08)", borderRadius: "4px", zIndex: 2}} />
                                <div style={{width: "100%", borderRadius: "32px", overflow: "hidden", aspectRatio: "9/16"}}>
                                    <video src={kupavideo} muted autoPlay loop playsInline style={{width: "100%", height: "100%", objectFit: "cover", display: "block"}} />
                                </div>
                                <div style={{position: "absolute", top: "30px", left: "50%", transform: "translateX(-50%)", background: "rgba(0,0,0,0.82)", borderRadius: "10px", padding: "8px 12px", backdropFilter: "blur(8px)", whiteSpace: "nowrap"}}>
                                    <div style={{display: "flex", alignItems: "center", gap: "7px"}}>
                                        <span style={{fontSize: "15px"}}>🇹🇷</span>
                                        <span style={{color: "#FFD700", fontWeight: 900, fontSize: "17px"}}>3</span>
                                        <span style={{color: "rgba(255,255,255,0.3)", fontSize: "9px"}}>—</span>
                                        <span style={{color: "#FFD700", fontWeight: 900, fontSize: "17px"}}>1</span>
                                        <span style={{fontSize: "15px"}}>🇧🇷</span>
                                    </div>
                                    <div style={{color: "rgba(255,255,255,0.38)", fontSize: "7px", letterSpacing: "2px", textAlign: "center", marginTop: "2px"}}>MAÇ SONU</div>
                                </div>
                                <div style={{position: "absolute", bottom: "22px", right: "18px", background: "rgba(0,0,0,0.7)", borderRadius: "5px", padding: "3px 8px", color: "rgba(255,255,255,0.45)", fontSize: "9px", letterSpacing: "1px", fontWeight: 600}}>720×1280</div>
                            </div>
                        </div>

                        {/* Info */}
                        <div className="col-lg-9">
                            <div style={{display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(74,222,128,0.10)", border: "1px solid rgba(74,222,128,0.25)", color: "#4ade80", fontSize: "11px", fontWeight: 700, letterSpacing: "1px", padding: "6px 14px", borderRadius: "20px", marginBottom: "20px"}}>
                                🎬 REWARDED VIDEO — ÖDÜLLÜ VİDEO
                            </div>
                            <h3 style={{color: "#fff", fontSize: "clamp(22px, 3vw, 36px)", fontWeight: 900, marginBottom: "14px", lineHeight: 1.15}}>
                                Rewarded Video<br /><span style={{color: "#FFD700"}}>Zirvede Kalıyor.</span>
                            </h3>
                            <p style={{color: "rgba(255,255,255,0.52)", fontSize: "15px", lineHeight: 1.75, marginBottom: "36px", maxWidth: "460px"}}>
                                Kullanıcıya ödül sunan format, en yüksek tamamlanma oranıyla markalar için en etkili tercih olmaya devam ediyor. Maç sonucu içeriğiyle birleşince etki katlanıyor.
                            </p>

                            <div style={{display: "flex", gap: "40px", flexWrap: "wrap", marginBottom: "36px"}}>
                                {[
                                    {val: "92%", label: "Tamamlanma Oranı"},
                                    {val: "$14", label: "Ort. eCPM"},
                                    {val: "78%", label: "Etkileşim Oranı"},
                                ].map(m => (
                                    <div key={m.label}>
                                        <div style={{color: "#FFD700", fontWeight: 900, fontSize: "42px", lineHeight: 1}}>{m.val}</div>
                                        <div style={{color: "rgba(255,255,255,0.38)", fontSize: "11px", letterSpacing: "1px", marginTop: "6px", textTransform: "uppercase"}}>{m.label}</div>
                                    </div>
                                ))}
                            </div>

                            <div style={{display: "flex", gap: "12px", flexWrap: "wrap"}}>
                                {[
                                    {label: "Format", val: "VAST Etiketi / Video Dosyası"},
                                    {label: "Maks. Boyut", val: "5 MB"},
                                    {label: "Boyutlar", val: "1280×720 / 720×1280"},
                                ].map(s => (
                                    <div key={s.label} style={{background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", padding: "12px 18px"}}>
                                        <div style={{color: "rgba(255,255,255,0.32)", fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "5px"}}>{s.label}</div>
                                        <div style={{color: "#fff", fontSize: "13px", fontWeight: 600}}>{s.val}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                    </div>
                </div>

                {/* ── Format 2: Interstitial Video ── */}
                <div className="container" style={{paddingTop: "80px", paddingBottom: "100px"}}>
                    <div className="row align-items-center g-4">

                        {/* Info — left */}
                        <div className="col-lg-5 order-lg-1 order-2">
                            <div style={{display: "inline-flex", alignItems: "center", gap: "8px", background: "rgba(96,165,250,0.10)", border: "1px solid rgba(96,165,250,0.25)", color: "#60a5fa", fontSize: "11px", fontWeight: 700, letterSpacing: "1px", padding: "6px 14px", borderRadius: "20px", marginBottom: "20px"}}>
                                📺 INTERSTITIAL VIDEO — GEÇİŞ REKLAMI
                            </div>
                            <h3 style={{color: "#fff", fontSize: "clamp(22px, 3vw, 36px)", fontWeight: 900, marginBottom: "14px", lineHeight: 1.15}}>
                                Interstitial Video<br /><span style={{color: "#60a5fa"}}>Hızla Yükseliyor.</span>
                            </h3>
                            <p style={{color: "rgba(255,255,255,0.52)", fontSize: "15px", lineHeight: 1.75, marginBottom: "36px"}}>
                                Penaltı anları, gol sevinçleri ve kritik maç geçişlerinde tam ekran format markanızı unutulmaz kılıyor. Yüksek görünürlük, güçlü akılda kalıcılık.
                            </p>

                            <div style={{display: "flex", gap: "40px", flexWrap: "wrap", marginBottom: "36px"}}>
                                {[
                                    {val: "85%", label: "Tamamlanma Oranı"},
                                    {val: "$11", label: "Ort. eCPM"},
                                    {val: "94%", label: "Görünürlük Oranı"},
                                ].map(m => (
                                    <div key={m.label}>
                                        <div style={{color: "#60a5fa", fontWeight: 900, fontSize: "42px", lineHeight: 1}}>{m.val}</div>
                                        <div style={{color: "rgba(255,255,255,0.38)", fontSize: "11px", letterSpacing: "1px", marginTop: "6px", textTransform: "uppercase"}}>{m.label}</div>
                                    </div>
                                ))}
                            </div>

                            <div style={{display: "flex", gap: "12px", flexWrap: "wrap"}}>
                                {[
                                    {label: "Format", val: "VAST Etiketi / Video Dosyası"},
                                    {label: "Maks. Boyut", val: "5 MB"},
                                    {label: "Boyutlar", val: "1280×720 / 720×1280"},
                                ].map(s => (
                                    <div key={s.label} style={{background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: "10px", padding: "12px 18px"}}>
                                        <div style={{color: "rgba(255,255,255,0.32)", fontSize: "10px", letterSpacing: "1px", textTransform: "uppercase", marginBottom: "5px"}}>{s.label}</div>
                                        <div style={{color: "#fff", fontSize: "13px", fontWeight: 600}}>{s.val}</div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Phone mockup — right */}
                        <div className="col-lg-7 order-lg-2 order-1">
                            <div style={{maxWidth: "280px", width: "100%", margin: "0 auto", background: "#111827", border: "3px solid rgba(255,255,255,0.10)", borderRadius: "44px", padding: "14px", boxShadow: "0 40px 100px rgba(0,0,0,0.7)", position: "relative"}}>
                                <div style={{position: "absolute", top: "14px", left: "50%", transform: "translateX(-50%)", width: "56px", height: "5px", background: "rgba(255,255,255,0.08)", borderRadius: "4px", zIndex: 2}} />
                                <div style={{width: "100%", borderRadius: "32px", overflow: "hidden", aspectRatio: "9/16"}}>
                                    <video src={kupavideo} muted autoPlay loop playsInline style={{width: "100%", height: "100%", objectFit: "cover", display: "block"}} />
                                </div>
                                <div style={{position: "absolute", top: "30px", left: "50%", transform: "translateX(-50%)", background: "rgba(0,0,0,0.82)", borderRadius: "10px", padding: "8px 12px", backdropFilter: "blur(8px)", whiteSpace: "nowrap"}}>
                                    <div style={{display: "flex", alignItems: "center", gap: "7px"}}>
                                        <span style={{fontSize: "15px"}}>🇩🇪</span>
                                        <span style={{color: "#60a5fa", fontWeight: 900, fontSize: "17px"}}>2</span>
                                        <span style={{color: "rgba(255,255,255,0.3)", fontSize: "9px"}}>—</span>
                                        <span style={{color: "#60a5fa", fontWeight: 900, fontSize: "17px"}}>2</span>
                                        <span style={{fontSize: "15px"}}>🇦🇷</span>
                                    </div>
                                    <div style={{color: "rgba(255,255,255,0.38)", fontSize: "7px", letterSpacing: "2px", textAlign: "center", marginTop: "2px"}}>MAÇ SONU</div>
                                </div>
                                <div style={{position: "absolute", bottom: "22px", right: "18px", background: "rgba(0,0,0,0.7)", borderRadius: "5px", padding: "3px 8px", color: "rgba(255,255,255,0.45)", fontSize: "9px", letterSpacing: "1px", fontWeight: 600}}>720×1280</div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>

        </React.Fragment>
    );
}

export default Kupa;